import type { ItemDef, ResourceId } from '../types';

export const ITEMS: Record<ResourceId, ItemDef> = {
  coin: { id: 'coin', name: { en: 'Coin', pt: 'Moeda' }, sell: 0, kind: 'drop' },
  xp: { id: 'xp', name: { en: 'Experience', pt: 'Experiência' }, sell: 0, kind: 'drop' },
  wood: { id: 'wood', name: { en: 'Wood', pt: 'Madeira' }, sell: 1, kind: 'drop' },
  ore: { id: 'ore', name: { en: 'Iron Ore', pt: 'Minério' }, sell: 2, kind: 'drop' },
  hide: { id: 'hide', name: { en: 'Hide', pt: 'Couro' }, sell: 2, kind: 'drop' },
  herb: { id: 'herb', name: { en: 'Herb', pt: 'Erva' }, sell: 1, kind: 'drop' },
  ether: {
    id: 'ether',
    name: { en: 'Ether Shard', pt: 'Fragmento de Éter' },
    sell: 12,
    kind: 'drop',
    hint: {
      en: 'It hums when no one is watching.',
      pt: 'Vibra quando ninguém está olhando.',
    },
  },
  plank: { id: 'plank', name: { en: 'Plank', pt: 'Tábua' }, sell: 4, kind: 'craft' },
  ingot: { id: 'ingot', name: { en: 'Iron Ingot', pt: 'Lingote' }, sell: 9, kind: 'craft' },
  salve: { id: 'salve', name: { en: 'Salve', pt: 'Unguento' }, sell: 6, kind: 'craft' },
  charm: { id: 'charm', name: { en: 'Bone Charm', pt: 'Amuleto Ósseo' }, sell: 14, kind: 'craft' },
  shortSword: {
    id: 'shortSword',
    name: { en: 'Short Sword', pt: 'Espada Curta' },
    sell: 40,
    kind: 'craft',
  },
  cart: { id: 'cart', name: { en: 'Cart', pt: 'Carroça' }, sell: 22, kind: 'craft' },
  reinforcedCharm: {
    id: 'reinforcedCharm',
    name: { en: 'Reinforced Charm', pt: 'Amuleto Reforçado' },
    sell: 55,
    kind: 'craft',
  },
  elixir: { id: 'elixir', name: { en: 'Elixir', pt: 'Elixir' }, sell: 30, kind: 'craft' },
  anvilPiece: {
    id: 'anvilPiece',
    name: { en: 'Anvil Piece', pt: 'Peça de Bigorna' },
    sell: 48,
    kind: 'craft',
  },
  crystal: {
    id: 'crystal',
    name: { en: 'Crystal Shard', pt: 'Fragmento de Cristal' },
    sell: 18,
    kind: 'drop',
  },
  silk: { id: 'silk', name: { en: 'Silk', pt: 'Seda' }, sell: 12, kind: 'drop' },
  bone: { id: 'bone', name: { en: 'Bone', pt: 'Osso' }, sell: 3, kind: 'drop' },
  lantern: {
    id: 'lantern',
    name: { en: 'Lantern', pt: 'Lanterna' },
    sell: 65,
    kind: 'craft',
  },
  tome: {
    id: 'tome',
    name: { en: 'Tome', pt: 'Tomo' },
    sell: 90,
    kind: 'craft',
  },
  reliquary: {
    id: 'reliquary',
    name: { en: 'Reliquary', pt: 'Relicário' },
    sell: 150,
    kind: 'craft',
  },
  standard: {
    id: 'standard',
    name: { en: 'Royal Standard', pt: 'Estandarte Real' },
    sell: 200,
    kind: 'craft',
  },
  swordOfFirstCut: {
    id: 'swordOfFirstCut',
    name: { en: 'Sword of First Cut', pt: 'Espada do Primeiro Corte' },
    sell: 0,
    kind: 'quest',
    hint: {
      en: 'The first blade you forged. It is described in the ledger with unusual length.',
      pt: 'A primeira lâmina que você forjou. O livro-razão a descreve com extensão incomum.',
    },
  },
};
